export const device = {
	tab: {
		deviceStatus: "Dispositivos",
		deviceBars: "Dispositivo por Bar",
	},
};
